import { RootState } from '@redux/types';

export const blindTestSelector = (state: RootState) => state.blindTest.blindTest;
